import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
interface Props {
  onClose: () => void;
}
const Notes = ({ onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="text-center bg-theme bg-opacity-30 rounded-0 p-2 fw-bold mb-4">
        {t('TemplateConstructionExplanations')}
      </div>

      <br />

      <div className="row">
        <div className="col-md-12">
          <div className="bg-inverse bg-opacity-10 rounded-2 p-2 mb-3  ">
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-0 text-center">
                <Icon
                  icon="fluent-mdl2:text-field"
                  className="me-2 text-theme"
                  width="60"
                  height="60"
                />
                <span className="text-inverse text-opacity-50 fw-bold">{t('field')} : </span>
              </div>
              <span className="h6">{t('FieldName')}NTX_F</span>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="bg-inverse bg-opacity-10 rounded-2 p-2 mb-3  ">
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-0 text-center">
                <Icon icon="bi:qr-code-scan" className="me-2 text-theme" width="60" height="60" />
                <span className="text-inverse text-opacity-50 fw-bold">{t('QR')} :</span>
              </div>
              <span className="h6">
                {`(${t('Width')}$$${t('Height')}$$${t('Source')})`} NTX_QRCODE
              </span>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="bg-inverse bg-opacity-10 rounded-2 p-2 mb-3  ">
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-0 text-center">
                <Icon
                  icon="line-md:image-twotone"
                  className="me-2 text-theme"
                  width="60"
                  height="60"
                />
                <span className="text-inverse text-opacity-50 fw-bold">{t('Image')} : </span>
              </div>
              <span className=" h6">
                {' '}
                {`(${t('Width')}$$${t('Height')}$$${t('Source')})`} NTX_PIC
              </span>
              {/* <span className=" h6"> (العرض$$الإرتفاع$$المسار)NTX_PIC</span> */}
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="bg-inverse bg-opacity-10 rounded-2 p-2 mb-3  ">
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-0 text-center">
                <Icon
                  icon="material-symbols-light:barcode-scanner-rounded"
                  className="me-2 text-theme"
                  width="60"
                  height="60"
                />
                <span className="text-inverse text-opacity-50 fw-bold">{t('Barcode')} : </span>
              </div>
              <span className=" h6">
                {`(${t('Width')}$$${t('Height')}$$${t('Source')})`} NTX_BARCODE
              </span>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="bg-inverse bg-opacity-10 rounded-2 p-2 mb-3  ">
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-0 text-center">
                <Icon
                  icon="material-symbols:table-rows-narrow-rounded"
                  className="me-2 text-theme"
                  width="60"
                  height="60"
                />
                <span className="text-inverse text-opacity-50 fw-bold">
                  {t('RepetitionLinesInTable')} :{' '}
                </span>
              </div>
              <span className="  h6">NTX_TROW</span>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex gap-2">
        <button
          type="button"
          className="btn btn-lg me-1 btn-default w-100 rounded-0"
          onClick={onClose}>
          <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
        </button>
      </div>
    </>
  );
};

export default Notes;
